import axios from "axios";
import Cookies from "js-cookie";
import GlobalVar from "../config/globalVar";
import { METHOD, ENDPOINTS } from "../services/index";
import { getcookieFunc } from "../utils/useCookies";

let accessToken = getcookieFunc();
let userInfo = Cookies.get("userInfo") && JSON.parse(Cookies.get("userInfo"));

let config = {
  method: METHOD.get,
  headers: {
    Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
    // userId: `${JSON.parse(accessToken.cookieData.userInfo)?.email}`
  },
};

export const getTransactions = (e, type, accessTokenF) => {
  config.url = `${GlobalVar.BASE_URL}transactions/${
    ENDPOINTS[`${type}`]
  }?pageNumber=${e}&pageSize=10`;
  if (Cookies.get("userInfo")) {
    config.headers = {
      Authorization: `Bearer ${accessTokenF?.cookieData?.accessToken}`,

      userId: JSON.parse(Cookies.get("userInfo")).id,
    };
  } else {
    config.headers = {
      Authorization: `Bearer ${accessTokenF?.cookieData?.accessToken}`,
      // userId: `${JSON.parse(accessToken.cookieData.userInfo)?.email}`
      // userId : JSON.parse(Cookies.get('userInfo')).id
    };
  }
  // config.headers = {
  //   Authorization: `Bearer ${accessTokenF?.cookieData?.accessToken}`,
  //   // userId: `${JSON.parse(accessToken.cookieData.userInfo)?.email}`
  //   // userId : JSON.parse(Cookies.get('userInfo')).id
  // };
  config.method = METHOD.get;
  return axios(config).then((res) => res.data);
};

export const getTransactionsDetail = (transactionId) => {
  config.url = `${GlobalVar.BASE_URL}transaction/${transactionId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.method = METHOD.get;
  return axios(config).then((res) => res.data);
};

export const getOrgsDetails = (orgId) => {
  config.method = METHOD.get;
  config.data = null;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/view?organisationId=${orgId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;

  return axios(config).then((res) => res.data);
};

export const getDownloadDoc = (transactionId) => {
  config.url = `${GlobalVar.BASE_URL}transaction/${transactionId}/download`;
  config.headers = {
    "Content-type": "application/zip",
    Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
    userId: JSON.parse(Cookies.get("userInfo")).id,
  };
  config.method = METHOD.get;
  return axios(config).then((res) => res.data);
};

export const addUser = (orgId, createUserForm) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/addUser?organisationId=${orgId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = createUserForm;
  return axios(config).then((res) => res.data);
};

export const addOrg = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/create`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const addVendor = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/vendor`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const editVendor = (data, id) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}v1/vendor/${id}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const searchSelect = (e, endpoint) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}${endpoint}name=${e}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const login = (data) => {
  config.headers = {
    "Content-Type": "application/json",
  };
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}user/v1/login`;
  config.data = data;
  return axios(config).then((res) => res.data);
};

// this api is deprecated
// export const emailVer = (email, accessTokenF) => {
//   config.headers = {
//     Authorization: `Bearer ${accessTokenF}`,
//   };
//   config.method = METHOD.get;
//   config.url = `${GlobalVar.BASE_URL}user/v1/email?email=${email}`;
//   return axios(config).then((res) => res.data);
// };

export const updateTransactionRes = (data, transactionId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}transaction/${transactionId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getPresignedURL = (transactionId, name) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}transaction/generatePresignedUrl?transactionId=${transactionId}&fileName=${name}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const getPresignedURLVendor = (vendorId, name) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/vendor/generatePresignedUrl?vendorId=${vendorId}&fileName=${name}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const getPresignedURLOrg = (OrgId, name) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/generatePresignedUrl?organisationId=${OrgId}&fileName=${name}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const getAllPurposes = (searchInput) => {
  config.method = METHOD.get;
  if (searchInput) {
    config.url = `${GlobalVar.BASE_URL}v1/paymentPurpose/search?PaymentPurposeDescriptionAsPerRBI=${searchInput}`;
  } else {
    config.url = `${GlobalVar.BASE_URL}v1/paymentPurpose/search`;
  }
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const getVendorById = (e) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/vendor/${e}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const postLeegalityDoc = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/esign`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getFilesList = ({ transactionId, orgId, userId }) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/transaction/${transactionId}/files?organisationId=${orgId}&userId=${userId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const updateUser = (data, orgId, userId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/updateUser?organisationId=${orgId}&userId=${userId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const setFileMetaData = (transactionID, data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}transaction/${transactionID}/addTransactionDocument`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const setFileVendorMetaData = (vendorID, data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/vendor/${vendorID}/addVendorDocument`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getTransactionDocs = async (transactionID) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/transaction/${transactionID}/documents`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
};
export const getVendorDocs = async (vendorID) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/vendor/${vendorID}/documents`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
};

export const postTransaction = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}transaction/initiate`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getPresignedUrlTransaction = (fileName) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}transaction/initiate/generatePresignedUrl?fileName=${fileName}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const putUpdateOrg = (data, orgId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getCheckList = async (transactionId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}transaction/checklist/${transactionId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
};

export const addOrgDocsMeta = (orgId, data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/documents`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getOrgCDocs = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/documents`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const postCAfirm = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/caFirm`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const addBankDetails = (orgId, data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const postCA = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}${data.caFirmId}/v1/charteredAccountant`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const addAdBankDetails = (orgId, data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/ad-bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getBankDetails = (bankId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/bank-details/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const getAdBankDetails = (bankId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/ad-bank-details/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const putBankDetails = (orgId, bankId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/bank-details/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config)
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const putAdBankDetails = (orgId, bankId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/ad-bank-details/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export async function getAllMessages(transactionId, firmId) {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}message/v1/${transactionId}?companyId=${firmId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
}

export async function postMessage(data, firmId, userId) {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}message/v1`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  config.data.companyId = `${firmId}`;
  config.data.userId = `${userId}`;
  const res = await axios(config);
  return res.data;
}

export const generatePreSignedUrlMsg = async (fileName) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}message/v1/generatePresignedUrl?fileName=${fileName}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
};

export async function getAllDrafts15cb(transactionId) {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}transactions/${transactionId}/draft15CB`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  const res = await axios(config);
  return res.data;
}
export const putDraftStatus = async (docId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}transactions/draft15CB/${docId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  const res = await axios(config);
  return res.data;
};

export const getPreviewLink = (docId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}message/v1/document/${docId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const postBank = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/bank`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const putBank = (data, bankId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}v1/bank/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const postBankUser = (data, bankId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}bank/${bankId}/v1/bank-user`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getBankMainDetails = (bankId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/bank/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const getBankUsers = (bankId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}bank/${bankId}/v1/bank-users`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const getBankUserDetails = (bankId, userId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}bank/${bankId}/v1/bank-user/${userId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const putBankUser = (data, bankId, userId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}bank/${bankId}/v1/bank-user/${userId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getAllVendorName = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/vendors/all`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAllOrgName = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/organisations/all `;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getFilteredTransaction = async (params, pageNumber) => {
  let queryParams = "";
  Object.keys(params).foreach((item) => {
    if (params[item]?.length !== 0) {
      queryParams += `${item}=${params[item]}&`;
    }
  });
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/transaction/filter?${queryParams}pageNumber=${pageNumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getOrgDocs = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}sign-up/v1/presignedUrlsForAllDocuments `;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getCkycAuthDocs = async (email, pan) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}sign-up/v1/presignedUrlsForOrganisationDocuments?emailId=${email}&pan=${pan} `;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getFilteredOrg = async (filtersParams, pageNumber) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v2/organisations/filter?${filtersParams}pageNumber=${pageNumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getListViewOrg = async (pageNumber) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v2/organisations/filter?pageNumber=${pageNumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error?.message);
  }
};
export const getListAllCities = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/address/cities`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error?.message);
  }
};
export const updateOrg = (data, id) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${id}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config)
    .then((res) => res.data)
    .catch((err) => {
      return err.response.data;
    });
};
export const createOrgSignup = (data) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/create`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const addOrgDocs = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/documents`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const postBankNew = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getBankNew = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const postUbo = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}${orgId}/ubo`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const putUbo = (data, orgId, uboId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}${orgId}/ubo/${uboId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getAllUBOs = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}${orgId}/ubos`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const getPresignedURlDirector = async (orgId, fileName) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/temp-pre-signed-url?fileName=${fileName} `;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const postAddress = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}v1/organisation/${orgId}/address`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const putAddress = (data, orgId, addressId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}v1/organisation/${orgId}/address/${addressId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const postAuthSignatory = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}${orgId}/authorized-signatory`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const putAuthSignatory = (orgId, authId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}${orgId}/authorized-signatory/${authId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
export const getAllAuths = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}${orgId}/authorized-signatories`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const postDirectorDetails = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}${orgId}/director`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config)
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
export const putDirectorDetails = (orgId, dirId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}${orgId}/director/${dirId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config)
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
export const getDirectors = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}${orgId}/directors`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const postMultipleDirectorDetails = (data, orgId) => {
  config.method = METHOD.post;
  config.url = `${GlobalVar.BASE_URL}${orgId}/directors`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};

export const getProbeDetails = (panNum) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/pan-details?pan=${panNum}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const downloadUrl = (orgId, url) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/download-url?path=${url}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const probDocsCheck = (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/update-doc-from-probe`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const getPresignedAuthURL = (orgId, fileName) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/generatePresignedUrl?organisationId=${orgId}&fileName=${fileName}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};
export const putInwardCharges = (orgId, charges) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/charges/update`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = charges;
  return axios(config).then((res) => res.data);
};

// pg charges
export const putInwardPGCharges = (orgId, charges) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/payglocal-charges/update`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = charges;
  return axios(config).then((res) => res.data);
};

export const getFilteredTransactionAll = async (filters, pageNumber) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v2/transaction/filter?${filters}pageNumber=${pageNumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAllTransaction = async (pageNumber) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v2/transaction/filter?pageNumber=${pageNumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getInwardTransactions = async (pageNumber, orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}inward/v2/receivable?pageSize=10&pageNumber=${pageNumber}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAllOpsMember = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/list`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllLeads = async () => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/pendingSignup`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getFilteredOrgDocsDownload = async (filtersParams) => {
  let accessToken = getcookieFunc();
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}organisation/v2/organisations/filter/export?${filtersParams}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getListViewOrgDocsDownload = async (filters) => {
  let accessToken = getcookieFunc();
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}organisation/v2/organisations/filter/export?${filters}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error?.message);
  }
};

export const getFilteredTransactionAllDownload = async (
  filters,
  productType = "OUTWARD"
) => {
  let accessToken = getcookieFunc();
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}v2/transaction/filter/export?productType=${productType}&${filters}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAllTransactionDownload = async (
  filters,
  productType = "OUTWARD"
) => {
  let accessToken = getcookieFunc();
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v2/transaction/filter/export`;
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}v2/transaction/filter/export?productType=${productType}&${filters}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const activeOrg = async (orgId, userId, opsUserId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/org/${orgId}/activate?userId=${userId}&opsUserId=${opsUserId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const updateBank = async (orgId, bankId, data) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${orgId}/bank-details/${bankId}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAdBankDetailsOutward = async (organisationId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${organisationId}/ad-bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const getBankDetailsOutward = async (organisationId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}user/v1/organisation/${organisationId}/bank-details`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAof = async (orgId) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/org/${orgId}/generate-aof`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBillingsCa = async (pagenumber, filters) => {
  config.method = METHOD.get;
  if (filters) {
    config.url = `${GlobalVar.BASE_URL}organisation/v1/billing${filters}&pageNumber=${pagenumber}&pageSize=10`;
  } else {
    config.url = `${GlobalVar.BASE_URL}organisation/v1/billing?pageNumber=${pagenumber}&pageSize=10`;
  }
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBillingsCaOrg = async (orgId, pagenumber) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/${orgId}/billing?pageNumber=${pagenumber}&pageSize=10`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const commonSearch = (searchField, searchQuery) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/search?${searchField}=${searchQuery}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const searchOrg = (orgName) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/search?name=${orgName}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const downloadMainBillings = async (filters) => {
  let accessToken = getcookieFunc();
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}organisation/v1/billing/download${filters}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const downloadSubBillings = async (orgId) => {
  let accessToken = getcookieFunc();
  try {
    const res = await axios.get(
      `${GlobalVar.BASE_URL}v1/${orgId}/billing/download`,
      {
        headers: {
          Authorization: `Bearer ${accessToken.cookieData.accessToken}`,
          userId: JSON.parse(Cookies.get("userInfo")).id,
        },
        responseType: "blob",
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const checkIfFieldExist = async (type, field, fieldValue) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}${type}/v1/exists/field/${field}/value/${fieldValue}`;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSignzyDetails = (pan) => {
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}v1/signzy-details/${pan}`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  return axios(config).then((res) => res.data);
};

export const getNextInvoice = async (data) => {
  let orgId = localStorage.getItem("orgId");
  config.method = METHOD.get;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/download-url?path=${data}`;
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const xflowPurposeCodeUpdate = (data, orgId) => {
  config.method = METHOD.put;
  config.url = `${GlobalVar.BASE_URL}organisation/v1/${orgId}/purpose-code/update`;
  config.headers.userId = JSON.parse(Cookies.get("userInfo")).id;
  config.data = data;
  return axios(config).then((res) => res.data);
};
